window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-cognitive:not(.initialized)').forEach(cognitive => {
    const recalculatePosition = () => {
      const iqPoint = cognitive.querySelector('.product-cognitive-point');
      const iq = iqPoint.dataset.iq ? parseInt(iqPoint.dataset.iq) : 0;
      let y = 89.5;
      let x = 0;

      const positions = [
        [77, 88.5],
        [78, 87.5],
        [79, 86.5],
        [80, 86],
        [81, 84.5],
        [82, 83.5],
        [83, 80.5],
        [84, 77.5],
        [85, 73.5],
        [86, 70.5],
        [87, 67],
        [88, 62.5],
        [89, 58.5],
        [90, 51.5],
        [91, 38.5],
        [92, 20.5],
        [93, 13.5],
        [94, 9.5],
        [95, 6.5],
        [96, 4],
        [97, 2.5],
        [98, 1.5],
        [99, 0.5],
        [100, 0.5],
        [101, 0.5],
        [102, 1.5],
        [103, 2.5],
        [104, 4],
        [105, 6.5],
        [106, 9.5],
        [107, 13.5],
        [108, 20.5],
        [109, 38.5],
        [110, 51.5],
        [111, 58.5],
        [112, 62.5],
        [113, 67],
        [114, 70.5],
        [115, 73.5],
        [116, 76.5],
        [117, 78.5],
        [118, 80.5],
        [119, 82.5],
        [120, 83.5],
        [121, 84.5],
        [122, 85.5],
        [123, 86.5],
        [124, 86.5],
        [125, 87.5],
        [127, 88.5],
        [130, 89.5]
      ];

      positions.forEach(pos => {
        if (iq >= pos[0]) {
          y = pos[1];
        }
      });

      const calcPositionInRange = (min, max, value) => {
        const range = max - min;
        const valueInRange = value - min;

        return 1 - ((range - valueInRange) / range);
      };

      if (iq < 75) {
        x = 12 * calcPositionInRange(0, 75, iq);
      } else if (iq >= 75 && iq < 85) {
        x = 12 + (31.2 - 12) * calcPositionInRange(75, 85, iq);
      } else if (iq >= 85 && iq < 100) {
        x = 31.2 + (49.3 - 31.2) * calcPositionInRange(85, 100, iq);
      } else if (iq >= 100 && iq < 115) {
        x = 49.3 + (67.6 - 49.3) * calcPositionInRange(100, 115, iq);
      } else if (iq >= 115 && iq < 130) {
        x = 67.6 + (86.7 - 67.6) * calcPositionInRange(115, 130, iq);
      } else {
        x = 86.7 + (100 - 86.7) * calcPositionInRange(130, 150, iq);

        if (x > 100) {
          x = 100;
        }
      }

      iqPoint.style.top = y + '%';
      iqPoint.style.left = x + '%';
    };

    cognitive.classList.add('initialized');
    recalculatePosition();

    const iqDebug = document.getElementById('iq-debug');

    if (document.getElementById('iq-debug')) {
      iqDebug.addEventListener('change', e => {
        cognitive.querySelector('.product-cognitive-point').dataset.iq = iqDebug.value;
        document.getElementById('iq-value').innerHTML = iqDebug.value;
        recalculatePosition();
      });

      iqDebug.addEventListener('mousemove', e => {
        cognitive.querySelector('.product-cognitive-point').dataset.iq = iqDebug.value;
        document.getElementById('iq-value').innerHTML = iqDebug.value;
        recalculatePosition();
      });
    }
  });
});